module.exports = __webpack_public_path__ + "static/img-products-92a24a43161d80bbc8543e3d638359dd.png";